export default __webpack_public_path__ + "static/media/dribbble-btn.b19cde7c.png";